import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class MenuListButton extends Component {
  render () {
    const { onClick, name, className } = this.props;
    return (
      <li>
        <button
          className={`menu-button no-outline ${className || ''}`}
          onClick={onClick}
        >{name}</button>
      </li>
    );
  }
}

MenuListButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/ui/MenuListButton.js